// extracted by mini-css-extract-plugin
export default {"input":"LoginInput_input__XJXZi"};